<script>
class QrCodeError extends Error {
  static INIT = 1001; //初始化失败
  static NO_CAMARE = 1002; //没有摄像头
  constructor(code, message) {
    super(message);
    this.code = code;
    this.message = message;
  }
}
const defalutConfig = {
  qrWidth: 200, //扫描框宽高
  qrTopWeight: 0.17, //扫描框距上方距离权重,
  scanLineColor: "#1890ff", //扫描线颜色
  scanBoxColor: "#fff", //扫描框颜色
  backButtonColor: "#1890ff", //返回按钮颜色
  backButtonText: "返回", //返回按钮文字
  tipText: "请在蓝色方框内扫描防伪码", //提示文字
  decodeFrame: 20, //每20帧解一次码,
  cornerWidth: 4, //扫描角宽度
  cornerLength: 12, //扫描角长度
  cornerColor: "#1890ff" //扫描角颜色
};

let parseTime = 0;
// export component
export default {
  name: "QRcode",
  props: {
    onError: { type: Function, default: e => {} }, //加载失败回调
    onSuccess: { type: Function, default: value => {} }, //扫描成功回调
    onClose: { type: Function, default: () => {} }, // 关闭扫描的回调
    workerPath: { type: String, default: "./qrWork.js" }, //qrWork.js 服务器相对目录
    config: { type: Object, default: () => {} } //扫码配置
  },
  data() {
    return {
      visible: false,
      qrConfig: { ...defalutConfig, ...this.$props.config }
    };
  },
  methods: {
    drawBox(canvas, left, top, width, height) {
      //画扫描框
      canvas.lineWidth = 2;
      canvas.strokeStyle = this.qrConfig.scanBoxColor;
      canvas.strokeRect(left, top, width, height);
    },
    drawShadowBox(canvas, left, top, width, height) {
      //画背景
      canvas.fillStyle = "#00000099";
      canvas.fillRect(left, top, width, height);
    },
    drawCorners(canvas, left, top, width, height) {
      //画角
      canvas.lineWidth = this.qrConfig.cornerWidth;
      canvas.strokeStyle = this.qrConfig.cornerColor;
      canvas.beginPath();

      canvas.moveTo(left, top + this.qrConfig.cornerLength);
      canvas.lineTo(left, top);
      canvas.lineTo(left + this.qrConfig.cornerLength, top);

      canvas.moveTo(left, top + height - this.qrConfig.cornerLength);
      canvas.lineTo(left, top + height);
      canvas.lineTo(left + this.qrConfig.cornerLength, top + height);

      canvas.moveTo(left + width - this.qrConfig.cornerLength, top);
      canvas.lineTo(left + width, top);
      canvas.lineTo(left + width, top + this.qrConfig.cornerLength);

      canvas.moveTo(left + width, top + height - this.qrConfig.cornerLength);
      canvas.lineTo(left + width, top + height);
      canvas.lineTo(left + width - this.qrConfig.cornerLength, top + height);

      canvas.stroke();
    },
    drawLine(canvas, left, top, width, progress) {
      //画扫描线
      canvas.lineWidth = 2;
      canvas.strokeStyle = this.qrConfig.scanLineColor;
      canvas.beginPath();
      canvas.moveTo(left, top + ((progress * 2) % width));
      canvas.lineTo(left + width, top + ((progress * 2) % width));
      canvas.stroke();
    },
    updateImage() {
      if (
        this.canvasRef != undefined &&
        this.video.readyState === this.video.HAVE_ENOUGH_DATA
      ) {
        const canvas = this.canvasRef.getContext("2d");
        this.canvasRef.width = this.canvasRef.clientWidth;
        this.canvasRef.height = this.canvasRef.clientHeight;
        let drawHeight = this.video.videoHeight;
        let drawWidth = this.video.videoWidth;
        if (
          this.canvasRef.clientWidth / this.canvasRef.clientHeight >
          this.video.videoWidth / this.video.videoHeight
        ) {
          drawHeight = Math.round(
            (this.video.videoWidth * this.canvasRef.height) /
              this.canvasRef.width
          );
        } else {
          drawWidth = Math.round(
            (this.video.videoHeight * this.canvasRef.width) /
              this.canvasRef.height
          );
        }
        canvas.drawImage(
          this.video,
          (this.video.videoWidth - drawWidth) / 2,
          (this.video.videoHeight - drawHeight) / 2,
          drawWidth,
          drawHeight,
          0,
          0,
          this.canvasRef.width,
          this.canvasRef.height
        );
        const top = Math.round(this.qrConfig.qrTopWeight * window.innerHeight);
        const width = Math.round(
          (this.qrConfig.qrWidth / window.innerWidth) * this.canvasRef.width
        );
        const left = Math.round((this.canvasRef.width - width) / 2);
        this.drawShadowBox(canvas, 0, 0, window.innerWidth, top);
        this.drawShadowBox(
          canvas,
          0,
          top + width,
          window.innerWidth,
          window.innerHeight - top - width
        );
        this.drawShadowBox(canvas, 0, top, left, width);
        this.drawShadowBox(
          canvas,
          left + width,
          top,
          window.innerWidth - left - width,
          width
        );
        this.drawLine(canvas, left, top, width, parseTime);
        this.drawBox(canvas, left, top, width, width);
        this.drawCorners(canvas, left, top, width, width);
        if (parseTime % this.qrConfig.decodeFrame == 0) {
          let imageData = canvas.getImageData(left, top, width, width);
          this.qrWork.postMessage({
            method: "parse",
            data: imageData.data,
            width: imageData.width,
            height: imageData.height
          });
        }
      }
      if (this.visible == true) {
        parseTime++;
        requestAnimationFrame(this.updateImage);
      }
    },
    show() {
      //显示
      const { onError } = this.$props;
      if (navigator.mediaDevices == undefined) {
        onError(new QrCodeError(QrCodeError.NO_CAMARE, "No camera device detected.Please download IVPS Tour APP to bind."));
        return;
      }
      // if (!this.qrWorkInit) {
      //   onError(new QrCodeError(QrCodeError.INIT, "Worker加载失败"));
      //   return;
      // }
      // if (!this.jsQRInit) {
      //   onError(new QrCodeError(QrCodeError.INIT, "jsQR加载失败"));
      //   return;
      // }
      let _me = this;
      navigator.mediaDevices
        .getUserMedia({
          video: {
            facingMode: "environment",
            width: { ideal: 1280 },
            height: { ideal: 720 }
          }
        })
        .then(stream => {
          if (_me.visible == false) {
            _me.visible = true;
          }
          _me.localstream = stream;
          _me.video.srcObject = stream;
          _me.video.setAttribute("playsinline", true); // required to tell iOS safari we don't want fullscreen
          _me.video.play();
          requestAnimationFrame(_me.updateImage);
        })
        .catch(e => {
          onError(e);
        });
    },
    closeOnclick() {
      const { onClose } = this.$props;
      onClose()
    },
    close() {
      //关闭
      this.localstream && this.localstream.getTracks()[0].stop();
      this.localstream = undefined;
      if (this.video != undefined) {
        this.video.pause();
        this.video.src = "";
        this.video.srcObject = null;
      }
      this.visible = false;
    }
  },
  mounted() {
    let _me = this;
    this.canvasRef = this.$refs.canvasRef;
    const { onError, onSuccess, workerPath } = this.$props;
    this.qrWork = new Worker(workerPath);
    this.qrWork.onerror = event => {
      onError(new QrCodeError(QrCodeError.INIT, "Worker加载失败"));
    };
    this.qrWork.postMessage({
      method: "init"
    });
    this.qrWork.onmessage = event => {
      switch (event.data.method) {
        case "parse": {
          if (event.data.data != undefined && event.data.data.length > 0) {
            // 成功扫描到了
            onSuccess(event.data.data);
          }
        }
        case "init": {
          _me.qrWorkInit = true;
          _me.jsQRInit = event.data.data;
        }
      }
    };
    this.video = document.createElement("video");
    this.show();
  },
  destroyed() {
    this.close();
  },
  updated() {
    this.canvasRef = this.$refs.canvasRef;
  },
  render() {
    return (
      <div
        class={this.visible ? "videoModalShow" : "videoModal"}
        style={{
          padding: "0px",
          margin: "0px",
          height: "100%",
          width: "100%",
          top: "0px",
          maxWidth: "100%",
          position: "fixed",
          left: "0px",
          zIndex: 99
        }}
      >
        <div
          style={{
            height: "100%",
            width: "100%",
            display: "flex",
            flexDirection: "column",
            position: "relative"
          }}
        >
          <canvas
            ref="canvasRef"
            style={{
              height: "0px",
              width: "100%",
              flex: 1
            }}
          ></canvas>
          <div
            style={{
              position: "absolute",
              top: "0px",
              bottom: "0px",
              left: "0px",
              right: "0px",
              height: "100%",
              width: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center"
            }}
          >
            <div
              style={{
                textAlign: "center",
                color: "#fff",
                paddingLeft: "32px",
                paddingRight: "32px",
                background: "#00000099",
                fontSize: "12px",
                height: "32px",
                borderRadius: "16px",
                paddingLeft: "16px",
                paddingRight: "16px",
                display: "flex",
                alignItems: "center",
                marginTop:
                  25 +
                  Math.round(this.qrConfig.qrTopWeight * window.innerHeight) +
                  this.qrConfig.qrWidth +
                  "px"
              }}
            >
              {this.qrConfig.tipText}
            </div>
            <div style={{ flex: 1 }} />
            <div
              type="primary"
              shape="round"
              size="large"
              style={{
                paddingLeft: "32px",
                paddingRight: "32px",
                background: this.qrConfig.backButtonColor,
                height: "40px",
                borderRadius: "40px",
                color: "#fff",
                textAlign: "center",
                fontSize: "14px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginBottom: "24px"
              }}
              onClick={() => this.closeOnclick()}
            >
              {this.qrConfig.backButtonText}
            </div>
          </div>
        </div>
      </div>
    );
  }
};
</script>
<style>
.videoModal {
  opacity: 0;
  visibility: hidden;
  transform: scale(0);
  transition: visibility 0s linear 0.25s, opacity 0.25s 0s, transform 0.25s;
}
.videoModalShow {
  opacity: 1;
  visibility: visible;
  transform: scale(1);
  transition: visibility 0s linear 0s, opacity 0.25s 0s, transform 0.25s;
}
</style>
